import FileActivity from './FileActivity.component';

export default FileActivity;
